import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   margin-bottom: 7.5px;

   &.withLine {
      position: relative;
      padding-bottom: 17.5px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
   }
   .select {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      > div { 
         width: 100% !important;
         min-width: 100% !important; 
      }
   }
   button {
      &:first-of-type {
         font-size: 17px;
         min-width: 40px;
         width: 40px;
         margin-left: 7.5px;
      }
      &:last-of-type {
         min-width: 90px;
         width: 90px;
         margin-left: 5px;
      }
   }
`;